module.exports = __webpack_public_path__ + "static/media/IMG_0809.fa718cbb.jpg";